import { __assign, __awaiter, __extends, __generator } from "tslib";
import { StratusClient } from '../stratus-client';
/**
 * Client for making Account Management Service API calls.
 */
var AccountMgtSvcClient = /** @class */ (function (_super) {
    __extends(AccountMgtSvcClient, _super);
    function AccountMgtSvcClient() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.apiName = 'ws-hp.com/accountmgtsvc';
        _this.apiVersion = '2';
        _this.accountsEndpoint = '/accounts';
        return _this;
    }
    /**
     * Returns the expected schema of create account API.
     *
     * @returns schema in object format
     */
    AccountMgtSvcClient.createAccountSchema = function () {
        return {
            $schema: 'http://json-schema.org/schema#',
            type: 'object',
            required: ['resourceId'],
            additionalProperties: true,
            properties: {
                resourceId: {
                    type: 'string',
                },
            },
        };
    };
    /**
     * Creates a new UCDE account on behalf of the authenticated user.
     *
     * @param {Account|null} account object to be created
     * @param {object} headers optional custom request headers
     * @returns Axios response object
     */
    AccountMgtSvcClient.prototype.createAccount = function (account, headers) {
        return __awaiter(this, void 0, void 0, function () {
            var request;
            return __generator(this, function (_a) {
                request = {
                    url: this.accountsEndpoint,
                    data: __assign({}, account),
                    validationSchema: AccountMgtSvcClient.createAccountSchema(),
                };
                if (headers) {
                    request['headers'] = __assign({}, headers);
                }
                return [2 /*return*/, this.jarvisWebHttpInstance.post(request)];
            });
        });
    };
    /**
     * Returns the expected schema for the create invitation response object.
     *
     * @returns schema in object format
     */
    AccountMgtSvcClient.inviteUserSchema = function () {
        return {
            $schema: 'http://json-schema.org/schema#',
            type: 'object',
            required: ['email', 'roleName', 'tenantResourceId', 'userResourceId'],
            additionalProperties: true,
            properties: {
                email: {
                    type: 'string',
                },
                roleName: {
                    type: 'string',
                },
                tenantResourceId: {
                    type: 'string',
                },
                userResourceId: {
                    type: 'string',
                },
            },
        };
    };
    /**
     * Creates a Invite of User on behalf of the authenticated user.
     *
     * @param {string} accountId account id of the authenticated user
     * @param {string} email email Id of the new User
     * @returns Axios response object
     */
    AccountMgtSvcClient.prototype.inviteUser = function (accountId, email, roleResourceId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.jarvisWebHttpInstance.post({
                        url: "".concat(this.accountsEndpoint, "/").concat(accountId, "/userinvitations"),
                        data: { email: email, roleResourceId: roleResourceId },
                        validationSchema: AccountMgtSvcClient.inviteUserSchema(),
                    })];
            });
        });
    };
    /**
     * Creates a Invite of User with role on behalf of the authenticated user.
     *
     * @param {string} tenantResourceId tenant's resource id of the authenticated user
     * @param {string} email email Id of the new User
     * @param {string} roleResourceId Role Resource id of the user
     * @returns Axios response object
     */
    AccountMgtSvcClient.prototype.inviteUserWithRole = function (tenantResourceId, email, roleResourceId, language, country) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.jarvisWebHttpInstance.post({
                        url: "".concat(this.accountsEndpoint, "/").concat(tenantResourceId, "/userinvitations"),
                        data: { email: email, roleResourceId: roleResourceId, language: language, country: country },
                        headers: {
                            'Content-Type': 'application/json',
                        },
                    })];
            });
        });
    };
    /**
     * Creates a resend Invite of User on behalf of the authenticated user.
     *
     * @param {string} tenantResourceId tenant's resource id of the authenticated user
     * @param {string} roleResourceId Role Resource id of the user
     * @returns Axios response object
     */
    AccountMgtSvcClient.prototype.resendInvitation = function (tenantResourceId, userResourceId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.jarvisWebHttpInstance.post({
                        url: "".concat(this.accountsEndpoint, "/").concat(tenantResourceId, "/userinvitations/").concat(userResourceId, "/resend"),
                        data: { id: tenantResourceId, userResourceId: userResourceId },
                    })];
            });
        });
    };
    /**
     * Get account details
     *
     * @param {string} userResourceId user's resource id of the
     * @returns Axios response object
     */
    AccountMgtSvcClient.prototype.getAccountTenantDetails = function (_a) {
        var userResourceId = _a.userResourceId;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                return [2 /*return*/, this.jarvisWebHttpInstance.get({
                        url: "".concat(this.accountsEndpoint, "/").concat(userResourceId),
                        headers: {
                            'Content-Type': 'application/json',
                        },
                    })];
            });
        });
    };
    /**
     * Delete a User on behalf of the authenticated user.
     *
     * @param {string} accountId account id of the authenticated user
     * @param {string} userResourceId email Id of the new User
     * @returns Axios response object
     */
    AccountMgtSvcClient.prototype.deleteUser = function (accountId, userResourceId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.jarvisWebHttpInstance.delete({
                        url: "".concat(this.accountsEndpoint, "/").concat(accountId, "/users/").concat(userResourceId),
                    })];
            });
        });
    };
    /**
     * Returns the expected schema for the get account response object.
     *
     * @returns schema in object format
     */
    AccountMgtSvcClient.getAccountSchema = function () {
        return {
            $schema: 'http://json-schema.org/schema#',
            type: 'object',
            required: ['resourceId', 'regionId'],
            additionalProperties: true,
            properties: {
                resourceId: {
                    type: 'string',
                },
                regionId: {
                    type: 'string',
                },
            },
        };
    };
    /**
     * Get a account on behalf of the authenticated user.
     *
     * @returns Axios response object
     */
    AccountMgtSvcClient.prototype.getAccount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.jarvisWebHttpInstance.get({
                        url: this.accountsEndpoint,
                        validationSchema: AccountMgtSvcClient.getAccountSchema(),
                    })];
            });
        });
    };
    /**
     * Update a account of region on behalf of the authenticated user.
     *
     * @param {string} accountId account's resourceid
     * @param {union} regionOrAccount region or Account object
     * @returns Axios response object
     */
    AccountMgtSvcClient.prototype.updateAccount = function (accountId, regionOrAccount) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.jarvisWebHttpInstance.patch({
                        url: "".concat(this.accountsEndpoint, "/").concat(accountId),
                        data: AccountMgtSvcClient._updateAccountData(regionOrAccount),
                    })];
            });
        });
    };
    AccountMgtSvcClient._updateAccountData = function (regionOrAccount) {
        if (typeof regionOrAccount === 'string') {
            var region = regionOrAccount;
            var data = {
                countrySet: [region],
            };
            return data;
        }
        return regionOrAccount;
    };
    /**
     * Returns the expected schema for account program infos.
     *
     * @returns schema in object format
     */
    AccountMgtSvcClient.programInfosSchema = function () {
        return {
            $schema: 'http://json-schema.org/schema#',
            type: 'object',
            required: ['planInfo', 'programInfoMap'],
            additionalProperties: true,
            properties: {
                planInfo: {
                    type: 'object',
                    required: ['programLevel', 'state'],
                    additionalProperties: true,
                    properties: {
                        programLevel: {
                            type: 'string',
                        },
                        state: {
                            type: 'string',
                        },
                    },
                },
                planInfoMap: {
                    type: 'object',
                },
            },
        };
    };
    /**
     * Retrieves program infos of the authenticated user
     * @param {string} accountId is a Parent Tenant Resource Id
     * @param {string} userId is a Current user's Resource Id
     * @returns Axios response object
     */
    AccountMgtSvcClient.prototype.getProgramInfos = function (accountId, userId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.jarvisWebHttpInstance.get({
                        url: "".concat(this.accountsEndpoint, "/").concat(accountId, "/users/").concat(userId, "/programinfos"),
                        validationSchema: AccountMgtSvcClient.programInfosSchema(),
                    })];
            });
        });
    };
    /**
     * Returns the expected schema for device program infos.
     *
     * @returns schema in object format
     */
    AccountMgtSvcClient.deviceProgramInfosSchema = function () {
        return {
            $schema: 'http://json-schema.org/schema#',
            type: 'object',
            required: ['programInfo'],
            additionalProperties: true,
            properties: {
                programInfo: {
                    type: 'object',
                    required: ['planInfo', 'entitlementList'],
                    additionalProperties: true,
                    properties: {
                        planInfo: {
                            type: 'object',
                            required: ['programLevel', 'state'],
                            additionalProperties: true,
                            properties: {
                                programLevel: {
                                    type: 'string',
                                },
                                state: {
                                    type: 'string',
                                },
                            },
                        },
                        entitlementList: {
                            type: 'array',
                            items: {
                                type: 'object',
                            },
                        },
                    },
                },
            },
        };
    };
    /**
     * Retrieves device program infos of the authenticated user
     *
     * @returns Axios response object
     */
    AccountMgtSvcClient.prototype.getDeviceProgramInfos = function (accountId, deviceId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.jarvisWebHttpInstance.get({
                        url: "".concat(this.accountsEndpoint, "/").concat(accountId, "/devices/").concat(deviceId, "/programinfos"),
                        validationSchema: AccountMgtSvcClient.deviceProgramInfosSchema(),
                    })];
            });
        });
    };
    /**
     * Returns the expected schema for the device entitlement status response object.
     *
     * @returns schema in object format
     */
    AccountMgtSvcClient.deviceEntitlementStatusSchema = function () {
        return {
            $schema: 'http://json-schema.org/schema#',
            type: 'object',
            required: ['targetProgramLevel', 'entitlementStatus', 'pollingInfo'],
            additionalProperties: true,
            properties: {
                targetProgramLevel: {
                    type: 'string',
                },
                entitlementStatus: {
                    type: 'object',
                    required: ['status'],
                    additionalProperties: true,
                    properties: {
                        status: {
                            type: 'string',
                        },
                    },
                },
                pollingInfo: {
                    type: 'object',
                    required: ['pollingFrequency', 'timeout'],
                    additionalProperties: true,
                    properties: {
                        pollingFrequency: {
                            type: 'integer',
                        },
                        timeout: {
                            type: 'integer',
                        },
                    },
                },
            },
        };
    };
    /**
     * Get account entitlement status
     * @param {string} accountId account's resourceid
     * @param {string} deviceCloudId
     * @returns Axios response object
     */
    AccountMgtSvcClient.prototype.deviceEntitlementStatus = function (accountId, deviceCloudId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.jarvisWebHttpInstance.get({
                        url: "".concat(this.accountsEndpoint, "/").concat(accountId, "/devices/").concat(deviceCloudId, "/entitlementstatus"),
                        validationSchema: AccountMgtSvcClient.deviceEntitlementStatusSchema(),
                    })];
            });
        });
    };
    /**
     * Returns the expected schema of validate device API.
     *
     * @returns schema in object format
     */
    AccountMgtSvcClient.validateDeviceSchema = function () {
        return {
            $schema: 'http://json-schema.org/schema#',
            type: 'object',
            required: ['deviceStatus', 'pollingFrequency', 'timeout'],
            additionalProperties: true,
            properties: {
                deviceStatus: {
                    type: 'object',
                    required: ['connectivityState'],
                    additionalProperties: true,
                    properties: {
                        connectivityState: {
                            type: 'string',
                        },
                        lastSeenTime: { anyOf: [{ type: 'string' }, { type: 'null' }] },
                        printerState: { anyOf: [{ type: 'string' }, { type: 'null' }] },
                    },
                },
                ecosystemStatus: {
                    type: 'string',
                },
                pollingFrequency: {
                    type: 'integer',
                },
                timeout: {
                    type: 'integer',
                },
            },
        };
    };
    /**
     * Validate user's device connectivity in the IoT shadow
     * @param {string} accountId account's resourceid
     * @param {string} uuid device's uuid
     * @param {object} headers optional custom request headers
     * @returns Axios response object
     */
    AccountMgtSvcClient.prototype.validateDevice = function (accountId, uuid, headers) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.jarvisWebHttpInstance.post({
                        url: "".concat(this.accountsEndpoint, "/").concat(accountId, "/devices/validate"),
                        headers: __assign({ 'Content-Type': 'application/json' }, headers),
                        data: { uuid: uuid },
                        validationSchema: AccountMgtSvcClient.validateDeviceSchema(),
                    })];
            });
        });
    };
    /**
     * Returns the expected schema of register device API.
     *
     * @returns schema in object format
     */
    AccountMgtSvcClient.registerDeviceSchema = function () {
        return {
            $schema: 'http://json-schema.org/schema#',
            type: 'object',
            required: ['cloudId'],
            additionalProperties: true,
            properties: {
                cloudId: {
                    type: 'string',
                },
                bizModel: {
                    type: 'string',
                },
                offer: {
                    type: 'integer',
                },
                programId: {
                    type: 'string',
                },
                selectedBizModel: {
                    type: 'string',
                },
                supplyType: {
                    type: 'string',
                },
                uuid: {
                    type: 'string',
                },
                imageList: {
                    type: 'array',
                    items: {
                        type: 'string',
                    },
                },
            },
        };
    };
    /**
     * Register a device to a given user
     * @param {string} accountId account's resourceid
     * @param {string|object} claimPostcard device's claim postcard
     * @param {string} productNumber device's SKU
     * @param {string} selectedBizModel user's biz model selection
     * @param {string} uuid device's uuid
     * @param {string|object} fingerprint optional device's fingerprint
     * @param {object} headers optional custom request headers
     * @returns Axios response object
     */
    AccountMgtSvcClient.prototype.registerDevice = function (accountId, claimPostcard, productNumber, selectedBizModel, uuid, fingerprint, programId, headers) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.jarvisWebHttpInstance.post({
                        url: "".concat(this.accountsEndpoint, "/").concat(accountId, "/devices"),
                        headers: __assign({ 'Content-Type': 'application/json' }, headers),
                        data: AccountMgtSvcClient._registerDeviceData(claimPostcard, productNumber, selectedBizModel, uuid, fingerprint, programId),
                        validationSchema: AccountMgtSvcClient.registerDeviceSchema(),
                    })];
            });
        });
    };
    AccountMgtSvcClient._registerDeviceData = function (claimPostcard, productNumber, selectedBizModel, uuid, fingerprint, programId) {
        var data = {
            autoClaimRequest: {
                claimPostcard: claimPostcard,
                productNumber: productNumber,
                selectedBizModel: selectedBizModel,
                uuid: uuid,
                fingerprint: fingerprint,
                programId: programId,
            },
        };
        return data;
    };
    /**
     * Delete a device from account for a given user.
     *
     * @param {string} accountId account id of the authenticated user
     * @param {string} cloudId cloud Id of the device
     * @param {object} opts other options, like query string params
     * @returns Axios response object
     */
    AccountMgtSvcClient.prototype.deleteDevice = function (accountId, cloudId, opts) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.jarvisWebHttpInstance.delete(__assign({ url: "/accounts/".concat(accountId, "/devices/").concat(cloudId) }, (opts ? opts : {})))];
            });
        });
    };
    /**
     * Updates the biz model of a device.
     *
     * @param {string} accountId id for the authenticated user
     * @param {string} cloudId id for the device
     * @param {string} bizModel new biz model for the device (E2E or Flex)
     * @returns Axios response object
     */
    AccountMgtSvcClient.prototype.updateDeviceBizModel = function (accountId, cloudId, bizModel) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.jarvisWebHttpInstance.patch({
                        url: "/accounts/".concat(accountId, "/devices/").concat(cloudId),
                        data: { bizModel: bizModel },
                    })];
            });
        });
    };
    return AccountMgtSvcClient;
}(StratusClient));
export { AccountMgtSvcClient };
//# sourceMappingURL=account-mgt-svc.js.map